import React from 'react';
import { TableRef } from '../typed';

export default function useTable(table?: TableRef): [TableRef | undefined] {
  const tableRef = React.useRef<TableRef>();

  if (!tableRef.current) {
    if (table) {
      tableRef.current = table;
    } else {
      tableRef.current = {};
    }
  }

  return [tableRef.current];
}
